import type { FC } from "react";

interface TooltipPayload {
  readonly color: string;
  readonly value: string;
  readonly name: string;
}

interface CustomTooltipProps {
  readonly active?: boolean;
  readonly payload?: TooltipPayload[];
  readonly label?: string;
}

/**
 * Renders a custom tooltip for Recharts-based charts
 */
export const CustomTooltip: FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length > 0) {
    return (
      <div className="bg-card border-border rounded-lg border p-2 shadow-lg dark:bg-gray-800">
        <p className="text-muted-foreground mb-1 text-xs">{label}</p>
        {payload.map((entry, index) => (
          <p
            key={`tooltip-${index}`}
            style={{ color: entry.color }}
            className="text-xs"
          >
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};
